import { useGLTF } from "@react-three/drei";
import { useRoomStore } from "../../store";
import { useMemo } from "react";
import * as THREE from "three";

function RandomDoor() {
  const { scene } = useGLTF("/models/door.glb");
  const scaleX = useRoomStore((s) => s.scaleX);
  const scaleZ = useRoomStore((s) => s.scaleZ);

  // Deep clone: tint door body black, keep knob white
  const clone = useMemo(() => {
    const cloned = scene.clone(true);
    cloned.traverse((child) => {
      if (child.isMesh) {
        const mats = Array.isArray(child.material) ? child.material : [child.material];
        child.material = mats.map((mat) => {
          const m = mat.clone();
          // Knob material is yellow (g > 0.5) → white; door body → black
          if (m.color && m.color.g < 0.5) {
            m.color = new THREE.Color(0x111111);
          } else {
            m.color = new THREE.Color(0xffffff);
          }
          return m;
        });
        if (child.material.length === 1) child.material = child.material[0];
      }
    });
    return cloned;
  }, [scene]);

  return (
    <group
      userData={{
        link: "/",
        isDoor: true,
        isRandomDoor: true,
        hoverText: "Visit a random room",
      }}
      scale={12}
      position={[scaleX > 50 ? -scaleX * 0.3 - 14 : -scaleX * 0.3 + 14, 6, (scaleZ * 0.99) / 2]}
    >
      <primitive object={clone} />
    </group>
  );
}

export default RandomDoor;
